import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { graphql, readInlineData } from "react-relay";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { currentArticleAtom } from "scmp-app/lib/current-item";
import type { articleHeadlineHeaderFeaturesContent$key } from "scmp-app/queries/__generated__/articleHeadlineHeaderFeaturesContent.graphql";

import { Container } from "./styles";

export type HeaderFeaturesArticleHeadlineProps = HeaderFeatureCommonProps & {
  isMagazineStyle?: boolean;
  isPostMagazineArticle?: boolean;
};

export const HeaderFeaturesArticleHeadline: FunctionComponent<
  HeaderFeaturesArticleHeadlineProps
> = ({ isMagazineStyle = false, isPostMagazineArticle = false, ...props }) => {
  const currentArticle = useAtomValue(currentArticleAtom);
  if (!currentArticle) return null;

  const data = readInlineData<articleHeadlineHeaderFeaturesContent$key>(
    graphql`
      fragment articleHeadlineHeaderFeaturesContent on Content @inline {
        headline
        socialHeadline
      }
    `,
    currentArticle,
  );

  const { headline, socialHeadline } = data ?? {};
  const displayHeadline = socialHeadline ?? headline ?? null;

  return (
    <Container
      $isMagazineStyle={isMagazineStyle}
      $isPostMagazineArticle={isPostMagazineArticle}
      {...getResponsiveProps(props)}
    >
      {displayHeadline}
    </Container>
  );
};

HeaderFeaturesArticleHeadline.displayName = "HeaderFeaturesArticleHeadline";
